import {makeStyles} from "@mui/styles";

export const useStyles = makeStyles({
  pageTitle: {
    lineHeight: '40px',
    '@media (max-width: 767px)': {
      lineHeight: '1.6',
      marginBottom: 16,
      whiteSpace: 'nowrap',
    },
  },
  filters: {
    marginBottom: 0,
    '@media (max-width: 767px)': {
      marginBottom: 0,
    }
  },
  filterWrapper: {
    padding: '16px 36px',
    '@media (max-width: 1200px)': {
      padding: '16px 24px',
    }
  },
  content: {},
  tableHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 0,
  },
});
